import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodOptionalString, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminKopilotValidatedInvoicesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/kopilot/validated-invoices',
  validateSearch: z.object({
    page: zodPage,
    query: zodOptionalString,
    status: z.enum(['all', 'validated', 'invalidated', 'to_revalidate']).default('all'),
    latestChanges: z.boolean().default(false),
    pharmacyId: zodOptionalId,
    labId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import(
    'pages/admin/KopilotInvoices/AdminKopilotValidatedInvoicesPage/AdminKopilotValidatedInvoicesPage'
  ).then((d) => d.Route)
);
